import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Agent, ClientPlanType, Profile } from 'core/models/agent';
import { AgentsService, PopUpService, ProfileService, UiService } from 'core/services';
import { AuthService } from 'app/auth/auth.service';
import { environment } from 'environments/environment';
import { URL_LOGO_ADMIN, URL_LOGO_CAMPUS, URL_LOGO_EDITOR } from 'core/assets/constants';

@Component({
  selector: 'lms-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent implements OnInit {
  @Input() user: Agent;
  public language = this.translate.currentLang;
  public dropdownVisible = false;
  public helpDropdownVisible = false;
  public appsDropdownVisible = false;
  public langDropdownVisible = false;
  public showClientDropdown = false;
  public clientDropdownVisible = false;
  public clients: any[];
  public selectedClient: any;
  public apps: any[];
  public myAccount: any;
  @Output() public showCookies: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public translate: TranslateService,
    public agentsService: AgentsService,
    public profileService: ProfileService,
    public uiService: UiService,
    public elementRef: ElementRef,
    public authService: AuthService,
    public popupService: PopUpService
  ) {}

  public ngOnInit(): void {
    this.clients = [];

    this.profileService.getLoggedUser$().subscribe((loggedUser: Profile) => {
      this.user = loggedUser;
      this.myAccount = {
        id: 'accounts',
        label: 'apps.accounts',
        url: environment.ACCOUNTS_URL
      };

      this.apps = [
        {
          id: 'admin',
          label: 'apps.admin',
          icon: URL_LOGO_ADMIN,
          url: '',
          shouldShow: true,
          state: 'active'
        },
        {
          id: 'editor',
          label: 'apps.editor',
          icon: URL_LOGO_EDITOR,
          url: environment.AUTHORING_URL,
          shouldShow: loggedUser?.isCreator,
          state: 'inactive'
        },
        {
          id: 'campus',
          label: 'apps.campus',
          icon: URL_LOGO_CAMPUS,
          url: environment.CAMPUS_URL,
          shouldShow: loggedUser?.isStudent,
          state: 'inactive'
        }
      ];

      if (loggedUser && loggedUser.roleOptions.scope === 'client' && loggedUser.clients.length > 1) {
        this.clients = loggedUser.clients.map((client) => {
          if (client.clientId === loggedUser.clientId) {
            this.selectedClient = client;
          }
          return { id: client.clientId, name: client.name };
        });
      }
    });
  }

  changeLanguage(language) {
    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      if (loggedUser && loggedUser.lang !== language) {
        this.language = language;
        this.translate.use(language);
        localStorage.setItem('backofficelanguage', language);
        const data = { lang: this.language, id: loggedUser.id } as Agent;
        this.agentsService.update(data).then(() => location.reload());
      }
    });
  }

  showClientChangeError(text = '') {
    this.popupService.showError({
      title: this.translate.instant('account.clientChangeError'),
      text
    });
  }

  changeSelectedClient(clientId) {
    this.profileService.changeSelectedClient(clientId, '/dashboard').catch((err) => this.showClientChangeError(err));
  }

  toggleHelpDropdown() {
    this.helpDropdownVisible = !this.helpDropdownVisible;
    this.appsDropdownVisible = false;
    this.langDropdownVisible = false;
    this.dropdownVisible = false;
    this.clientDropdownVisible = false;
  }

  toggleAppsDropdown() {
    this.appsDropdownVisible = !this.appsDropdownVisible;
    this.helpDropdownVisible = false;
    this.langDropdownVisible = false;
    this.dropdownVisible = false;
    this.clientDropdownVisible = false;
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
    this.appsDropdownVisible = false;
    this.langDropdownVisible = false;
    this.helpDropdownVisible = false;
    this.clientDropdownVisible = false;
  }
  toggleLangDropdown() {
    this.langDropdownVisible = !this.langDropdownVisible;
    this.appsDropdownVisible = false;
    this.helpDropdownVisible = false;
    this.dropdownVisible = false;
    this.clientDropdownVisible = false;
  }
  toggleClientDropdown() {
    this.clientDropdownVisible = !this.clientDropdownVisible;
    this.appsDropdownVisible = false;
    this.langDropdownVisible = false;
    this.helpDropdownVisible = false;
    this.dropdownVisible = false;
  }

  @HostListener('document:click', ['$event'])
  hide(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.clientDropdownVisible = false;
      this.appsDropdownVisible = false;
      this.dropdownVisible = false;
      this.helpDropdownVisible = false;
      this.langDropdownVisible = false;
    }
  }

  logout() {
    this.authService.logout();
    this.uiService.setLoginEnvironment();
  }

  launchApp(app) {
    open(app.url, '_blank');
  }

  /**
   * Open the cookies modal
   */
  public openCookiesConfig(): void {
    this.showCookies.emit(true);
    this.dropdownVisible = !this.dropdownVisible;
    this.appsDropdownVisible = false;
    this.langDropdownVisible = false;
    this.helpDropdownVisible = false;
    this.clientDropdownVisible = false;
  }
}
